import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import { studyEventFormSchemaServices } from "../../../../APIServices/studyEventFormSchemaServices";
import { studyEventManagementServices } from "../../../../APIServices/studyEventManagementServices";

const AddCustomEditCheckMetaForm = ({ getStudyLevelCustomEditCheck }) => {
  const [label, setLabel] = useState("");
  const [type, setType] = useState("global");
  const [schemaId, setSchemaId] = useState("");
  const [eventId, setEventId] = useState("");
  const [timePointId, setTimePointId] = useState("");
  const [fieldUnit, setFieldUnit] = useState("no");
  const [eventRows, setEventRows] = useState([]);
  const [eventSchema, setEventSchema] = useState([]);
  const [formId, setFormId] = useState("");
  const [fieldId, setFieldId] = useState("");
  const [fieldCode, setFieldCode] = useState("");
  const [customField, setCustomField] = useState("");
  const [customFieldData, setCustomFieldData] = useState("");
  const [version, setVersion] = useState("");
  const [category, setCategory] = useState("");
  const [mainVersion, setMainVersion] = useState("");
  const [queryMessage, setQueryMessage] = useState("");
  const [formMetadataList, setFormMetadataList] = useState([]);
  const [formFields, setFormFields] = useState([]);
  let { studyId } = useParams()
  const [buttonLoader, setButtonLoader] = useState(false)

  const addNewGlobalCustomEditCheck = async () => {
    setButtonLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.label = label
    userData.type = type
    if (type === "byEvent") {
      userData.schemaId = schemaId
      userData.eventId = eventId
      userData.timePointId = timePointId
    }
    userData.formId = formId
    userData.fieldId = fieldId
    userData.customField = customField
    userData.fieldCode = fieldCode
    userData.version = version
    userData.category = category
    userData.queryMessage = queryMessage
    let data = await studyLevelFormManagementServices.addNewStudyLevelCustomEditCheck(userData)
    if (data?.statusCode === 200) {
      clearForm()
      getStudyLevelCustomEditCheck()
    }
    setButtonLoader(false)
  }

  const clearForm = () => {
    setLabel("")
    setFieldId("")
    setType("global")
    setSchemaId("")
    setEventId("")
    setTimePointId("")
    setEventRows([])
    setEventSchema([])
    setFormId("")
    setVersion("")
    setCategory("")
    setCustomField("")
    setFieldCode("")
    setCustomFieldData("")
    setMainVersion("")
    setQueryMessage("")
    setFormFields([])
  }

  useEffect(() => {
    clearForm();
  }, []);

  const getEventBasedonSchema = async (e) => {
    let data = await studyEventFormSchemaServices.getEventBasedonSchema(studyId, schemaId);
    setEventRows(data?.data || []);
  };

  const getEventFormSchema = async (e) => {
    let data = await studyEventFormSchemaServices.getEventFormSchema(
      "active",
      studyId
    );
    setEventSchema(data?.data || []);
  };

  const getSchemaEventForms = async (e) => {
    let data = await studyEventManagementServices.getSchemaEventForms(
      studyId,
      schemaId,
      eventId,
      timePointId || "no"
    );
    setFormMetadataList(data?.data || []);
  };

  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();

  const getStudyLevelForm = async (e) => {
    let data = await studyLevelFormManagementServices.getStudyLevelForm(
      studyId,
      LoginCat,
      "active",
    );
    setFormMetadataList(data?.data || []);
  };

  const getStudyLevelFormFieldsByVersion = async () => {
    let data = await studyLevelFormManagementServices.getStudyLevelFormFieldsByVersion(
      studyId,
      formId,
      version
    );
    setFormFields(data?.data?.formFields || []);
  };

  const selectFormFieldData = (fieldId) => {
    setFieldId(fieldId)
    let fieldData = formFields?.find(item => item.id === Number(fieldId))
    setCustomFieldData(fieldData || "")
    if (fieldData?.type === "number" || fieldData?.type === "text") {
      let twoFieldCode = [
        { fieldCode: fieldData?.fieldName },
        { fieldUnitCode: fieldData?.fieldUnitName }
      ];
      for (const item of twoFieldCode) {
        if (item.fieldUnitCode === fieldCode) {
          setFieldCode(fieldData?.fieldUnitName)
          break;
        } else if (item.fieldCode === fieldCode) {
          setFieldCode(fieldData?.fieldName)
          break;
        }
      }
    } else {
      setFieldCode(fieldData?.fieldName)
    }
  }

  useEffect(() => {
    if (formId && version) {
      getStudyLevelFormFieldsByVersion()
    }
  }, [formId, version]);

  useEffect(() => {
    if (type === "byEvent") {
      getEventFormSchema()
      setFormMetadataList([])
    } else {
      getStudyLevelForm()
    }
    setSchemaId("")
    setEventId("")
    setTimePointId("")
    setEventRows([])
    setEventSchema([])
    setFormId("")
    setFieldId("")
    setVersion("")
    setCustomField("")
    setFieldCode("")
    setCustomFieldData("")
    setMainVersion("")
    setFormFields([])
  }, [type]);

  useEffect(() => {
    if (schemaId) {
      getEventBasedonSchema()
    }
    setEventId("")
    setTimePointId("")
    setFormId("")
    setFieldId("")
    setVersion("")
    setCustomField("")
    setFieldCode("")
    setCustomFieldData("")
    setMainVersion("")
    setFormFields([])
  }, [schemaId]);

  useEffect(() => {
    if (eventId) {
      getSchemaEventForms()
    }
    setFormId("")
    setFieldId("")
    setVersion("")
    setCustomField("")
    setFieldCode("")
    setCustomFieldData("")
    setMainVersion("")
    setFormFields([])
  }, [schemaId, eventId, timePointId]);

  useEffect(() => {
    setFieldId("")
    setVersion("")
    setCustomField("")
    setFieldCode("")
    setCustomFieldData("")
  }, [formId]);

  useEffect(() => {
    setFieldId("")
    setCustomField("")
    setFieldCode("")
    setCustomFieldData("")
  }, [version]);
  return (
    <div className="p-2">
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Label{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => setLabel(e.target.value)}
          value={label}
          className="br3"
          placeholder="Label"
          type="text"
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Type{" "}
          <abbr title="required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => setType(e.target.value)}
          className="br3"
          style={{ fontSize: 12 }}
        >
          <option selected={type === "global"} value="global">Global</option>
          <option selected={type === "byEvent"} value="byEvent">By Event</option>
        </Form.Select>
      </Form.Group>
      {type === "byEvent" &&
        <>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Schema{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              onChange={(e) => setSchemaId(e.target.value)}
              style={{ fontSize: 12 }}
              disabled={eventSchema?.length === 0}
              className="br3"
            >
              <option selected={schemaId === ""} value="">Select Schema</option>
              {eventSchema?.map((item, index) => (
                <option key={index} selected={schemaId === item?.schemaId} value={item?.schemaId}>{item?.schemaName}</option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Event{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              onChange={(e) => { setEventId(e.target.value); setTimePointId(e.target[e.target.selectedIndex].id) }}
              style={{ fontSize: 12 }}
              disabled={eventRows?.length === 0}
              className="br3"
            >
              <option selected={eventId === ""} value="">Select Event</option>
              {eventRows?.map((item, index) => (
                <option key={index} selected={eventId === item?.eventId} value={item?.eventId} id={item?.row?.["TIMEPOINTUNIQUEID"] || ""}>{item?.row?.["EVENTID"]} {item?.row?.["TIMEPOINTUNIQUEID"] && `(${item?.row?.["TIMEPOINTID"]})`}</option>
              ))}
              <option selected={eventId === "specialForm"} value="specialForm">Special Form</option>
            </Form.Select>
          </Form.Group>
        </>
      }
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Form{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => { setFormId(e.target.value); setMainVersion(e.target[e.target.selectedIndex].title) }}
          className="br3"
          disabled={formMetadataList?.length === 0}
          style={{ fontSize: 12 }}
        >
          <option selected={formId === ""} value="">Select Form</option>
          {formMetadataList?.map((item, index) => (
            <option key={index} selected={formId === item?.formId} value={item?.formId} title={item?.version}>{item?.formName}</option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Form Version{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => setVersion(e.target.value)}
          className="br3"
          disabled={!mainVersion}
          style={{ fontSize: 12 }}
        >
          <option selected={version === ""} value="">Select Version</option>
          {Array.from({ length: mainVersion }, (_, i) => i + 1)?.reverse()?.map((versionNumber, index) => (
            <option key={index} selected={Number(version) === versionNumber} value={versionNumber}>Version {versionNumber}</option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Form Field{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => { selectFormFieldData(e.target.value); setFieldUnit(e.target[e.target.selectedIndex].title); setCustomField(e.target[e.target.selectedIndex].id) }}
          className="br3"
          disabled={formFields?.length === 0}
          style={{ fontSize: 12 }}
        >
          <option selected={fieldId === ""} value="">Select Field</option>
          {formFields?.map((item, index) => (
            <option key={index} selected={Number(fieldId) === item?.id} value={item?.id} id={item?.customField} title={item?.fieldUnit}>{item?.fieldLabel}</option>
          ))}
        </Form.Select>
      </Form.Group>
      {(customField === "yes" || fieldUnit === "yes") &&
        <Form.Group className="mb-1">
          <Form.Label className="fw-bold mb-1">
            Sub-Fields{" "}
            <abbr title="required" className="text-danger">
              *
            </abbr>
          </Form.Label>
          <Form.Select
            onChange={(e) => setFieldCode(e.target.value)}
            className="br3"
            disabled={formFields?.length === 0}
            style={{ fontSize: 12 }}
          >
            <option selected={fieldCode === ""} value="">Select Sub-Field Code</option>
            <option selected={fieldCode === customFieldData?.fieldName} value={customFieldData?.fieldName}>{customFieldData?.fieldLabel}</option>
            {fieldUnit === "yes" &&
              <option selected={fieldCode === customFieldData?.fieldUnitName} value={customFieldData?.fieldUnitName}>{customFieldData?.fieldUnitLabel}</option>
            }
            {customField === "yes" &&
              <>
                {customFieldData?.referenceRangeLowerLimit === "yes" &&
                  <option selected={fieldCode === customFieldData?.referenceRangeLowerLimitName} value={customFieldData?.referenceRangeLowerLimitName}>{customFieldData?.referenceRangeLowerLimitLabel}</option>
                }
                {customFieldData?.referenceRangeUpperLimit === "yes" &&
                  <option selected={fieldCode === customFieldData?.referenceRangeUpperLimitName} value={customFieldData?.referenceRangeUpperLimitName}>{customFieldData?.referenceRangeUpperLimitLabel}</option>
                }
                {customFieldData?.referenceRangeIndicator === "yes" &&
                  <option selected={fieldCode === customFieldData?.referenceRangeIndicatorName} value={customFieldData?.referenceRangeIndicatorName}>{customFieldData?.referenceRangeIndicatorLabel}</option>
                }
                {customFieldData?.clinicalSignificance === "yes" &&
                  <option selected={fieldCode === customFieldData?.clinicalSignificanceName} value={customFieldData?.clinicalSignificanceName}>{customFieldData?.clinicalSignificanceLabel}</option>
                }
                {customFieldData?.customRemark === "yes" &&
                  <option selected={fieldCode === customFieldData?.customRemarkName} value={customFieldData?.customRemarkName}>{customFieldData?.customRemarkLabel}</option>
                }
              </>
            }
          </Form.Select>
        </Form.Group>
      }
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Category{" "}
          <abbr title="required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => setCategory(e.target.value)}
          className="br3"
          style={{ fontSize: 12 }}
        >
          <option selected={category === ""} value="">Select Category</option>
          <option selected={category === "query"} value="query">Auto Query</option>
          <option selected={category === "notification"} value="notification">Notification</option>
          <option selected={category === "includeExclude"} value="includeExclude">Inclusion/Exclusion</option>
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Query Message{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => setQueryMessage(e.target.value)}
          value={queryMessage}
          className="br3"
          placeholder="Query Message"
          as="textarea"
        />
      </Form.Group>
      <div className="text-end">
        <button
          disabled={
            type === "byEvent" ?
              (!label || !type || !schemaId || !eventId || !formId || !fieldCode || !customField || !fieldId || !version || !category || !queryMessage || buttonLoader)
              :
              (!label || !type || !formId || !fieldCode || !customField || !fieldId || !version || !category || !queryMessage || buttonLoader)
          }
          onClick={addNewGlobalCustomEditCheck}
          className="updateProfile"
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm"/> Adding...
            </div>
          ) : (
            "Add Check Meta"
          )}
        </button>
      </div>
    </div>
  );
};

export default AddCustomEditCheckMetaForm;
